import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { Subscription, interval } from 'rxjs';

interface QuickLink {
  icon: string;
  label: string;
  description: string;
  path: string;
}

@Component({
  selector: 'app-not-found',
  imports: [CommonModule],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent implements OnInit, OnDestroy {

  quickLinks: QuickLink[] = [
    { icon: 'map', label: 'Dashboard', description: 'Live facility map', path: '/device-map' },
    { icon: 'heart', label: 'Device Health', description: 'Sensor status & alerts', path: '/device-health' },
    { icon: 'chart', label: 'Analytics', description: 'Trends & reports', path: '/analytics' }
  ];

  redirectSeconds = 10;
  redirectCancelled = false;

  private countdownSub?: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.countdownSub = interval(1000).subscribe(() => {
      this.redirectSeconds--;

      if (this.redirectSeconds <= 0) {
        this.goHome();
      }
    });
  }

  ngOnDestroy(): void {
    this.countdownSub?.unsubscribe();
  }

  cancelRedirect(): void {
    this.redirectCancelled = true;
    this.countdownSub?.unsubscribe();
  }

  goHome(): void {
    this.countdownSub?.unsubscribe();
    this.router.navigateByUrl('/device-map');
  }
}
